import AutoComplete from '@tarekraafat/autocomplete.js'
import DOMPurify from 'dompurify'
import { createEvent } from './_helpers'

export default function autocomplete(page) {
  const autoCompleteInputs = page.querySelectorAll('[data-autocomplete-input]')
  const searchParams = new URLSearchParams(window.location.search)

  autoCompleteInputs.forEach(el => {
    let selectedValue = null
    const input = el.querySelector('input') || el
    const additionalFields = input.dataset.additionalFields.split(',')
    const additionalFieldsMap = {}
    const errorBlock = document.createElement('div')
    errorBlock.classList.add('autocomplete__error')
    el.append(errorBlock)

    additionalFields.forEach(field => {
      const hiddenInput = document.createElement('input')
      hiddenInput.setAttribute('type', 'text')
      hiddenInput.setAttribute('name', field.trim())
      hiddenInput.classList.add('visually-hidden')
      input.parentNode.insertBefore(hiddenInput, input.nextSibling)
      additionalFieldsMap[field] = hiddenInput

      if (searchParams.has(field)) {
        hiddenInput.value = searchParams.get(field)
      }
    })

    const keys = ['name', 'correspondance', 'commentaire']

    const autocompleteInstance = new AutoComplete({
      selector: () => input,
      data: {
        src: async query => {
          const source = await fetch(
            `${input.dataset.route}/${DOMPurify.sanitize(query.trim())}`
          )
          const data = await source.json()

          return data.map(res => ({
            ...res,
            correspondance: res.correspondance || '',
            commentaire: res.commentaire || '',
          }))
        },
        keys,
        cache: false,
        filter: list => {
          const newList = []

          for (let i = 0; i < list.length; i++) {
            const exists = !!newList.find(
              item =>
                item.value.name === list[i].value.name &&
                item.value.correspondance === list[i].value.correspondance &&
                item.value.commentaire === list[i].value.commentaire
            )

            if (!exists) {
              newList.push(list[i])
            }
          }

          return newList
        },
      },
      threshold: 1,
      wrapper: false,
      debounce: 300,
      searchEngine: 'loose',
      resultsList: {
        class: 'autocomplete__list',
        destination: () => input,
        position: 'afterend',
        tag: 'ul',
        noResults: true,
        maxResults: 20,
        element: (list, data) => {
          if (!data.results.length) {
            const message = document.createElement('li')
            message.innerHTML = `${window.localization?.foundNoResultsFor ||
              ''} "${data.query}"`
            list.prepend(message)
          }
        },
      },
      resultItem: {
        element: (item, data) => {
          item.innerHTML = `<span>${data.value.name}</span><span class="autocomplete__comment">${data.value.commentaire}</span>`
        },
        tag: 'li',
      },
      events: {
        input: {
          selection: e => {
            const feedback = e.detail
            if (feedback.selection.value) {
              input.value = feedback.selection.value[keys[0]]
              selectedValue = feedback.selection.value
              input.dispatchEvent(createEvent('change'))

              additionalFields.forEach(field => {
                additionalFieldsMap[field].value =
                  feedback.selection.value[field]
              })
            }
          },
          change: ({ target }) => {
            if (
              (!selectedValue && target.value.length) ||
              (selectedValue && selectedValue.name !== target.value)
            ) {
              errorBlock.innerHTML = target.dataset.errorMessage
              input.setAttribute('data-error', '')

              return
            }

            if (!selectedValue) {
              additionalFields.forEach(field => {
                additionalFieldsMap[field].value = ''
              })
            }

            errorBlock.innerHTML = ''
            input.removeAttribute('data-error')
          },
        },
      },
    })

    input.addEventListener('input', () => {
      selectedValue = null
    })

    input.closest('form').addEventListener('submit', e => {
      if (errorBlock.innerHTML.length) {
        e.preventDefault()
        input.focus()
        autocompleteInstance.open()
      }
    })
  })
}
